export class ObjectPool<T> {
  private objects: T[] = [];
  private last: number = -1;

  constructor(
    private factory: () => T,
    initCount = 100,
  ) {
    for (let i = 0; i < initCount; i++) {
      this.objects.push(factory());
    }
  }

  get(): T {
    this.last++;
    if (this.last >= this.objects.length) {
      for (let i = 0; i < 100; i++) {
        this.objects.push(this.factory());
      }
    }
    return this.objects[this.last];
  }

  release() {
    this.last = -1;
  }
}
